var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", [
    _vm._m(0),
    _vm._v(" "),
    _c("section", { staticClass: "section-padding section-solution" }, [
      _c("h2", { staticClass: "text-center" }, [
        _vm._v(_vm._s(_vm.$t("message.scb.benefits_title")))
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-sm-3 col-md-3 text-center" }, [
          _c("img", {
            attrs: { src: "/static/img/ic_benefit01.png", width: "60" }
          }),
          _vm._v(" "),
          _c("h3", [_vm._v(_vm._s(_vm.$t("message.scb.benefits_detail01")))])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-sm-3 col-md-3 text-center" }, [
          _c("img", {
            attrs: { src: "/static/img/ic_benefit02.png", width: "60" }
          }),
          _vm._v(" "),
          _c("h3", [_vm._v(_vm._s(_vm.$t("message.scb.benefits_detail02")))]),
          _vm._v(" "),
          _c("p", [_vm._v(_vm._s(_vm.$t("message.scb.benefits_detail02_01")))]),
          _vm._v(" "),
          _c("p", [_vm._v(_vm._s(_vm.$t("message.scb.benefits_detail02_02")))]),
          _vm._v(" "),
          _c("p", [_vm._v(_vm._s(_vm.$t("message.scb.benefits_detail02_03")))])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-sm-3 col-md-3 text-center" }, [
          _c("img", {
            attrs: { src: "/static/img/ic_benefit03.png", width: "60" }
          }),
          _vm._v(" "),
          _c("h3", [_vm._v(_vm._s(_vm.$t("message.scb.benefits_detail03")))])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-sm-3 col-md-3 text-center" }, [
          _c("img", {
            attrs: { src: "/static/img/ic_benefit04.png", width: "60" }
          }),
          _vm._v(" "),
          _c("h3", [_vm._v(_vm._s(_vm.$t("message.scb.benefits_detail04")))])
        ])
      ])
    ]),
    _vm._v(" "),
    _c("section", { staticClass: "section-padding-gray" }, [
      _c("h2", { staticClass: "text-center" }, [
        _vm._v(_vm._s(_vm.$t("message.scb.form_title")))
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-lg-6 offset-lg-3" }, [
          _c("div", { staticClass: "card" }, [
            _c("div", { staticClass: "card-body" }, [
              _c("div", { staticClass: "form" }, [
                _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c("label", { attrs: { for: "credit_card" } }, [
                      _vm._v(
                        _vm._s(_vm.$t("message.scb.credit_card_title")) + "*"
                      )
                    ]),
                    _vm._v(" "),
                    _c("cleave", {
                      ref: "creditCard",
                      staticClass: "form-control input-jumbo",
                      attrs: {
                        placeholder: "•••• •••• •••• ••••",
                        options: { creditCard: true }
                      },
                      model: {
                        value: _vm.creditCard,
                        callback: function($$v) {
                          _vm.creditCard = $$v
                        },
                        expression: "creditCard"
                      }
                    }),
                    _vm._v(" "),
                    _vm.creditCardStatus == 1
                      ? _c("p", { staticClass: "text-error" }, [_vm._m(1)])
                      : _vm.creditCardStatus == 2
                      ? _c("p", { staticClass: "text-error" }, [_vm._m(2)])
                      : _vm._e()
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "form-group" }, [
                  _c("label", { attrs: { for: "email" } }, [
                    _vm._v(_vm._s(_vm.$t("message.scb.email_title")) + "*")
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.formData.email,
                        expression: "formData.email"
                      }
                    ],
                    ref: "email",
                    staticClass: "form-control input-jumbo",
                    attrs: { type: "email", id: "email", required: "" },
                    domProps: { value: _vm.formData.email },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.formData, "email", $event.target.value)
                      }
                    }
                  }),
                  _vm._v(" "),
                  _vm.emailStatus == 1
                    ? _c("p", { staticClass: "text-error" }, [_vm._m(3)])
                    : _vm.emailStatus == 2
                    ? _c("p", { staticClass: "text-error" }, [_vm._m(4)])
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-group" }, [
                  _c("label", { attrs: { for: "tel" } }, [
                    _vm._v(_vm._s(_vm.$t("message.scb.tel_title")) + "*")
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.formData.tel,
                        expression: "formData.tel"
                      }
                    ],
                    ref: "tel",
                    staticClass: "form-control input-jumbo",
                    attrs: { type: "tel", id: "tel", required: "" },
                    domProps: { value: _vm.formData.tel },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.formData, "tel", $event.target.value)
                      }
                    }
                  }),
                  _vm._v(" "),
                  _vm.telStatus == 1
                    ? _c("p", { staticClass: "text-error" }, [_vm._m(5)])
                    : _vm._e()
                ])
              ]),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "button button-large button-block -cyan",
                  on: { click: _vm.submit }
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t(_vm.isVerifyingButtonMessage)) +
                      "\n            "
                  )
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "mt-4" }, [
                _c("p", [
                  _vm._v(_vm._s(_vm.$t("message.scb.campaign_remark_title")))
                ]),
                _vm._v(" "),
                _c("ul", { staticStyle: { "margin-left": "1.5rem" } }, [
                  _c("li", [
                    _vm._v(
                      _vm._s(_vm.$t("message.scb.campaign_remark_detail01"))
                    )
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(
                      _vm._s(_vm.$t("message.scb.campaign_remark_detail02"))
                    )
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(
                      _vm._s(_vm.$t("message.scb.campaign_remark_detail03"))
                    )
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(
                      _vm._s(_vm.$t("message.scb.campaign_remark_detail04"))
                    )
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(
                      _vm._s(_vm.$t("message.scb.campaign_remark_detail05"))
                    )
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(
                      _vm._s(_vm.$t("message.scb.campaign_remark_detail06"))
                    )
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(
                      _vm._s(_vm.$t("message.scb.campaign_remark_detail07"))
                    )
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-12" }, [
        _c("img", {
          staticClass: "img-fluid",
          attrs: { src: "/static/img/scb01.jpg" }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-12" }, [
        _c("img", {
          staticClass: "img-fluid",
          attrs: { src: "/static/img/scb02.jpg" }
        })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ul", { staticStyle: { "margin-left": "1.5rem" } }, [
      _c("li", [_vm._v("กรุณากรอกหมายเลขบัตร")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ul", { staticStyle: { "margin-left": "1.5rem" } }, [
      _c("li", [_vm._v("หมายเลขบัตรไม่ถูกต้อง")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ul", { staticStyle: { "margin-left": "1.5rem" } }, [
      _c("li", [_vm._v("กรุณากรอก Email")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ul", { staticStyle: { "margin-left": "1.5rem" } }, [
      _c("li", [_vm._v("Email ไม่ถูกต้อง")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ul", { staticStyle: { "margin-left": "1.5rem" } }, [
      _c("li", [_vm._v("กรุณากรอกหมายเลขโทรศัพท์")])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-373e5b54", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-373e5b54","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/others/SCB.vue
// module id = 2006
// module chunks = 0